export function appendSearchAvailabilityParams(params, state) {
    if (state.dateMode === 'flexible' && state.flexibleMonth) {
        params.set('dateMode', 'flexible');
        params.set('flexibleMonth', state.flexibleMonth);
        params.set('flexibleNights', state.flexibleNights);
        params.set('flexibleMaxNights', state.flexibleMaxNights);
    } else if (state.dateMode !== 'flexible' && state.dates) {
        params.set('dates', state.dates);
    }

    return params;
}
